let service = function (
	$rootScope, 
	$stateParams, 
	$timeout, 
	$q,
	Http, 
	Session,
	_
) {
	"ngInject";
	
	var filtering = false;
	var active = Session.get('activeFilters') ? Session.get('activeFilters') : {};
	var showFilters = false;
	var service = this;

	this.actives = () => active;
	this.log = (data) => {
		data.category_id = active.categories && active.categories.length === 1 ? active.categories[0] : null;
		return Http.post('/v1/filter/log', 'POST', data);
	}

	this.loadInterface = (filters) => {
		$rootScope.$broadcast('filters:interface', filters);
	}

	this.save = () => {
		Session.set('activeFilters', active);
	}

	this.get = (data) => Http.get('/v1/filter', false, data);

	this.products = (values, all) => {
		if(values !== undefined) {
			$rootScope.$broadcast('PRODUCTS_CHANGED', values, all);
		}
		return values;
	};

	this.setActive = (key, value) => {
		active[key] = value;
		service.save();
	}

	this.setAllActives = (obj) => {
		active = obj;
		service.save();
	}

	this.clearFilter = (attributeId) => {
		if (active.filters && active.filters[attributeId]) {
			delete active.filters[attributeId];
			if (_.isEmpty(active.filters)) delete active.filters;
			service.save();
		}
	}

	this.getActive = (key) => active[key];

	this.getActives = () => active;

	this.reload = () => {
		$rootScope.$broadcast('filters:reload');
	}

	this.change = (init) => {
		$rootScope.$broadcast('filters:changed', init);
	}

	this.pills = (pills) => {
		$rootScope.$broadcast('filters:pills', pills);
	}

	this.openFilters = () => {
		if(!showFilters) {
			showFilters = true;
		} else {
			showFilters = false;
		}

		$rootScope.$broadcast('filters:show', showFilters);
	};

	this.toggle = {
		brand: function(brand) {

			if (active.brands) {
				var index = active.brands.indexOf(brand.id);

				if (index === -1) {
					active.brands.push(brand.id);
				} else {
					active.brands.splice(index, 1);
				}
			} else {
				active.brands = [brand.id];
			}

			if (_.isEmpty(active.brands)) delete active.brands;

			service.save();

			$rootScope.$broadcast('filters:action', 'BRAND', brand.id);
		},
		definition: function(definition) {				
			if (active.definitions) {
				var index = active.definitions.indexOf(definition.id);

				if (index === -1) {
					active.definitions.push(definition.id);
				} else {
					active.definitions.splice(index, 1);
				}
			} else {
				active.definitions = [definition.id];
			}

			if (_.isEmpty(active.definitions)) delete active.definitions;

			service.save();

			$rootScope.$broadcast('filters:action', 'DEFINITION', definition.id);
		},
		category: function(category) {

			if (active.categories) {
				var index = active.categories.indexOf(category.id);

				if (index === -1) {
					active.categories.push(category.id);
				} else {
					active.categories.splice(index, 1);
				}
			} else {
				active.categories = [category.id];
			}

			if (_.isEmpty(active.categories)) {
				delete active.categories;
			} else {
				active.categories = active.categories.sort();
			}

			service.save();
		},
		price: function(price) {
			if (active.price) {
				var index = _.findIndex(active.price, function(activePrice) {
					return price.range.join('-') === activePrice;
				});

				if (index === -1) {
					active.price.push(price.range.join('-'));
				} else {
					active.price.splice(index, 1);
				}
			} else {
				active.price = [price.range.join('-')];
			}

			if (_.isEmpty(active.price)) delete active.price;

			service.save();

			$rootScope.$broadcast('filters:action', 'PRICE', price.range.join('-'));
		},
		filter: function(id, option) {
			if(!filtering && option.enabled) {
				filtering = true;

				if (!active.filters) {
					active.filters = {};
				}
				
				// if exists delete from array otherwise add
				if(active.filters[id]) {
					var filterOptions = active.filters[id];
					var idx = filterOptions.indexOf(option.id);
					if(idx > -1) {
						filterOptions.splice(idx, 1);
						if(!filterOptions.length) {
							delete active.filters[id];
						}
					} else {
						filterOptions.push(option.id);
					}
				} else {
					active.filters[id] = [option.id];
				}

				if (_.isEmpty(active.filters)) delete active.filters;
				
				filtering = false;

				service.save();

				$rootScope.$broadcast('filters:action', 'FILTER', option.id);
			}
		},
		range: function(id, option) {
			if(!filtering && option.enabled) {
				filtering = true;

				if (!active.filters) {
					active.filters = {};
				}
				
				if(active.filters[id]) {
					var filterOptions = active.filters[id];
					var idx = filterOptions.indexOf(option.range.join('-'));
					if(idx > -1) {
						filterOptions.splice(idx, 1);
						if(!filterOptions.length) {
							delete active.filters[id];
						}
					} else {
						filterOptions.push(option.range.join('-'));
					}
				} else {
					active.filters[id] = [option.range.join('-')];
				}
				
				if (_.isEmpty(active.filters)) delete active.filters;
				
				filtering = false;

				service.save();

				$rootScope.$broadcast('filters:action', 'RANGE', option.range.join('-'), id);
			}
		},
		promo: function(bool) {
			if (bool) active.promo = bool;
			if (!active.promo) delete active.promo;
			service.save();
		},
		deadstock: function(bool) {
			if (bool) active.deadstock = bool;
			if (!active.deadstock) delete active.deadstock;
			service.save();
		},
		margin: function(bool) {
			if (bool) active.margin = bool;
			if (!active.margin) delete active.margin;
			service.save();
		},
		webshop: function(bool) {
			if (bool) active.webshop = bool;
			service.save();
		}
	}

};

export default service;



// WEBPACK FOOTER //
// ./app/components/filter/filter.service.js